import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    successAddQuestion: false,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_SUCCESS_ADD_QUESTION:
            return { ...state, successAddQuestion: payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/add-question/add-question.reducer.js